import Axios from 'axios'
import Configs from '../config'

const fetch = Axios.create({
  baseURL: Configs.apiRoot
})

export default fetch